import { useParams } from 'react-router';

import { useWidgetData } from '../widgets/useWidgetData';

export function useInfluencerNameResolver(): (id: string) => string | undefined {
  const { influencerId = '' } = useParams();
  const { data } = useWidgetData('influencer-profile', {
    params: { influencerId },
    skip: influencerId === '',
  });
  return (id) => (id === influencerId ? data?.name : undefined);
}

/**
 * The industry's own label, from the page's data (the route segment is an id
 * — a UUID in live); a readable slug is title-cased while that loads.
 */
export function useIndustryLabelResolver(): (industry: string) => string | undefined {
  const { influencerId = '', industry: current = '' } = useParams();
  const { data } = useWidgetData('influencer-industry', {
    params: { influencerId, industry: current },
    skip: influencerId === '' || current === '',
  });
  return (industry) => {
    if (industry === current && data?.industryLabel) return data.industryLabel;
    if (UUID.test(industry)) return undefined;
    return industry
      .split('-')
      .filter(Boolean)
      .map((part) => `${part[0]?.toUpperCase() ?? ''}${part.slice(1)}`)
      .join(' ');
  };
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
